import frontendLog from '../libs/frontendLog';
import { Component, ReactElement } from 'react';
import { ErrorFallbackPage } from './errorFallback';

export class ErrorBoundary extends Component<any, any> {
  public static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props: any) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  public componentDidCatch(err: any, info: any) {
    // You can also log the error to an error reporting service
    frontendLog.error({ err, info }, 'ErrorBoundary.componentDidCatch');
  }

  public render(): ReactElement<any> {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback || <ErrorFallbackPage />;
    }

    return <>{this.props.children}</>;
  }
}
